import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SHEET_URL, LOCAL_STORAGE_KEYS } from "./constants";
import loginImg from "./img/loginfig.gif"; // Assuming you have a local image for the login GIF
// Google Fonts import for a modern look
const fontLink = document.createElement("link");
fontLink.href = "https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap";
fontLink.rel = "stylesheet";
document.head.appendChild(fontLink);


// Inject global styles to remove unwanted padding and scrollbars
const style = document.createElement("style");
style.innerHTML = `
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    /* overflow: hidden; */  // <-- REMOVE or COMMENT THIS LINE
    box-sizing: border-box;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
    background: transparent !important;
  }
  body {
    overscroll-behavior: none;
  }
`;
document.head.appendChild(style);

function Login({ onLoginSuccess }) {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ license: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUsers() {
      const res = await fetch(SHEET_URL);
      const text = await res.text();
      const rawData = JSON.parse(text.substr(47).slice(0, -2));
      // console.log("Fetched user data:", rawData);
      
      setUsers(rawData.table.rows.map(row => {
        // console.log("Password cell:", row.c[5]);
        // console.log("Password cell:", row);
        return {
          schoolName: row.c[0]?.v ?? "",
          standard: row.c[1]?.v ?? "",
          volume: row.c[2]?.v ?? "",
          name: row.c[3]?.v ?? "",
          license: row.c[4]?.v?.toString() ?? "",
          password: row.c[5]?.v?.toString() ?? "",
          status: row.c[6]?.v ?? "",
          // ...add more fields as needed, matching your sheet columns
          type: row.c[10]?.v ?? "",
          dob: row.c[11]?.v ?? "",
        }
      }));
    }
    fetchUsers();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const inputLicense = form.license.trim();
    const inputPassword = form.password.trim();

    const user = users.find(
      u =>
        u.license.trim() === inputLicense &&
        String(u.password).trim() === inputPassword &&
        (u.type === "Super Admin" || u.type === "Admin")
    );

    if (user) {
      // Exclude license and password from saved user details
      const { license, password, ...userDetails } = user;
      localStorage.setItem(LOCAL_STORAGE_KEYS.LOGGED_IN_USER, JSON.stringify(userDetails));
      onLoginSuccess(userDetails);
      navigate("/"); // Navigate to home or dashboard after successful login
    } else {
      setError("Invalid credentials or you do not have access.");
    }
  };

  // Styles
  const bgStyle = {
    minHeight: "100vh",
    minWidth: "100vw",
    background: "#f6fbff",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start", // Align content to the left
    fontFamily: "'Roboto', sans-serif",
    margin: 0,
    padding: 0,
    position: "relative",
    overflow: "hidden",
  };
  const cardStyle = {
    background: "transparent", // Make background transparent
    borderRadius: "0px",
    boxShadow: "none",
    display: "flex",
    width: "100vw",
    height: "100vh",
    minHeight: "100vh",
    minWidth: "100vw",
    overflow: "hidden",
    margin: 0,
    padding: 0,
    position: "relative",
  };
  const backgroundGifStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    objectFit: "cover", // Cover the entire screen
    zIndex: 1, // Behind the login form
  };
  const loginOverlayStyle = {
    position: "absolute",
    right: "1%", // Position from right instead of left
    top: "55%",
    transform: "translateY(-50%)", // Center vertically
    zIndex: 2, // Above the GIF
    background: "rgba(255, 255, 255, 0.95)", // Semi-transparent white background
    borderRadius: "16px",
    padding: "3rem 2.5rem",
    width: "400px",
    maxWidth: "90vw",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
    backdropFilter: "blur(10px)", // Add blur effect
  };
  const titleStyle = {
    fontSize: "2rem",
    fontWeight: 700,
    marginBottom: "0.5rem",
    color: "#263D75",
  };
  const subtitleStyle = {
    color: "#555",
    fontSize: "1rem",
    marginBottom: "2rem",
    lineHeight: 1.5,
  };
  const inputBoxStyle = {
    background: "#f7fafd",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    padding: "0.5rem 1rem",
    marginBottom: "1.2rem",
    border: "1px solid #e0e7ef",
  };
  const inputStyle = {
    border: "none",
    outline: "none",
    background: "transparent",
    fontSize: "1rem",
    flex: 1,
    padding: "0.75rem 0.5rem",
    fontFamily: "inherit",
  };
  const iconStyle = {
    color: "#a0aec0",
    fontSize: "1.2rem",
    marginRight: "0.5rem",
  };
  const buttonStyle = {
    width: "100%",
    padding: "0.8rem",
    background: "#263D75",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "1.1rem",
    fontWeight: "bold",
    cursor: "pointer",
    marginTop: "0.5rem",
    marginBottom: "1rem",
    transition: "background 0.2s",
    fontFamily: "inherit",
    boxShadow: "0 2px 8px rgba(38,61,117,0.08)",
  };
  const errorStyle = {
    color: "#e53e3e",
    marginBottom: "1rem",
    fontWeight: "bold",
    fontSize: "1rem",
    textAlign: "center",
  };
  const socialRow = {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginTop: "1.2rem",
  };
  const socialBtn = {
    background: "#f7fafd",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "1.2rem",
    boxShadow: "0 1px 4px rgba(44,62,80,0.07)",
    transition: "background 0.2s",
  };

  return (
    <div style={bgStyle}>
      <div style={cardStyle}>
        {/* Full Screen Background GIF */}
        <img
          src={loginImg}
          alt="Login Background Animation"
          style={backgroundGifStyle}
          onError={e => { 
            console.error("Could not load GIF from local path");
            e.target.style.display = "none"; 
          }}
        />
        
        {/* Login Form Overlay */}
        <div style={loginOverlayStyle}>
          <div style={titleStyle}>Welcome Back :)</div>
          <div style={subtitleStyle}>
            To keep connected with us please login with your license key and password.
          </div>
          {error && <div style={errorStyle}>{error}</div>}
          <form onSubmit={handleSubmit} autoComplete="off">
            <div style={inputBoxStyle}>
              <span style={iconStyle}>🔑</span>
              <input
                style={inputStyle}
                placeholder="License Key"
                value={form.license}
                autoFocus
                onChange={e => setForm({ ...form, license: e.target.value })}
              />
            </div>
            <div style={inputBoxStyle}>
              <span style={iconStyle}>🔒</span>
              <input
                style={inputStyle}
                placeholder="Password"
                type="password"
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
              />
            </div>
            <button style={buttonStyle} type="submit">
              Login Now
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;